"use client";

import LoginCard from "@/components/auth/LoginCard";

export default function LoginForm() {
	return <LoginCard variant="page" />;
}
